import { Component, computed, inject, input, signal, WritableSignal } from '@angular/core';
import { environment } from '@libs/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ICalculatePreview } from '@libs/interfaces/calculate-preview.interface';
import { DecimalPipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MOCK_PRODUCT_TOKEN, MockProduct } from '@libs/configs/calculate.token';

@Component({
  selector: 'app-calculate-details',
  templateUrl: `./calculate-details.component.html`,
  styleUrls: [`./templates/${environment.group}/styles.sass`, './calculate-details.component.sass'],
  standalone: true,
  imports: [TranslateModule, DecimalPipe, MatTooltipModule],
})
export class CalculateDetails {
  public isDetailsOutside = input(false);
  public preview = input.required<ICalculatePreview>();

  public previewValue = computed(() => this.preview());

  public activeTab: WritableSignal<string> = signal('');

  public mockProduct: MockProduct = inject(MOCK_PRODUCT_TOKEN);

  public get paymentsQuantity(): number {
    return Math.round(this.mockProduct.fullTerm / this.previewValue().term);
  }

  public showDetails(type: 'SCHEDULE' | 'DETAILS'): void {
    this.activeTab.set(type !== this.activeTab() ? type : '');
  }
}
